import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// Plays a message's voice in the listener's language, fetched on demand and cached.
export function useAudioQueue(roomId) {
  const urls = useRef({});
  const audio = useRef(new Audio());
  const [playing, setPlaying] = useState(null);

  const playNow = useCallback(async (id, lang) => {
    const a = audio.current;
    const key = `${id}:${lang}`;
    if (playing === key && !a.paused) {
      a.pause();
      setPlaying(null);
      return;
    }
    if (!urls.current[key]) {
      const { data } = await api.post(`/rooms/${roomId}/messages/${id}/speech`, null, { params: { lang }, responseType: "blob" });
      urls.current[key] = URL.createObjectURL(data);
    }
    a.pause();
    a.src = urls.current[key];
    setPlaying(key);
    a.onended = a.onerror = () => setPlaying(null);
    await a.play().catch(() => setPlaying(null));
  }, [playing, roomId]);

  useEffect(() => {
    const a = audio.current;
    const u = urls.current;
    return () => {
      a.pause();
      Object.values(u).forEach((x) => URL.revokeObjectURL(x));
    };
  }, []);

  return { playNow, playing };
}
